import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import menuItems from "constants/menuItems";

// material-ui
import { Box, List, Typography } from "@mui/material";
import userRole from "constants/userRole";

// project import
import NavItem from "./NavItem";

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const menu = useSelector((state) => state.menu);
  const currentlyLoggedInUser = JSON.parse(localStorage.getItem("user"));
  const [role, setRole] = useState();
  const [isEditable, setIsEditable] = useState(false);

  const { drawerOpen } = menu;

  useEffect(() => {
    setRole(currentlyLoggedInUser ? currentlyLoggedInUser.uRole : null);

    setIsEditable(
      role === userRole.ADMIN || role === userRole.MODERATOR ? true : false
    );
  }, [currentlyLoggedInUser]);

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case "collapse":
        return (
          <Typography
            key={menuItem.id}
            variant="caption"
            color="error"
            sx={{ p: 2.5 }}
          >
            collapse - only available in paid version
          </Typography>
        );
      case "item":
        return (currentlyLoggedInUser && menuItem?.id === menuItems.LOGIN) ||
          (currentlyLoggedInUser && menuItem?.id === menuItems.REGISTER) ||
          (!isEditable && menuItem?.id == menuItems.IMAGE_MANAGER) ||
          (!isEditable && menuItem?.id == menuItems.PDF_MANAGER)  ||
          (!isEditable && menuItem?.id == menuItems.USER_OBSERVED_PESTS)  ? (
          ""
        ) : (
          <NavItem sx={{ mb: 4 }} key={menuItem.id} item={menuItem} level={1} />
        );
      default:
        return (
          <Typography
            key={menuItem.id}
            variant="h6"
            color="error"
            align="center"
          >
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {!isEditable && item.title == "Admin Panel"
                ? ""
                : currentlyLoggedInUser && item.title == "Authentication" ? "":
                !currentlyLoggedInUser ? item.title
                : isEditable
                ? item.title
                : item.title}
            </Typography>
            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
